import makeStyles from '@mui/styles/makeStyles'

const getStatusColor = (status, theme) => {
  if (status === 'active') {
    return theme.palette.indicator.green
  }

  if (status === 'inactive') {
    return theme.palette.textLight
  }

  return theme.palette.indicator.red
}

const useStyles = makeStyles(theme => ({
  name: {
    display: 'flex',
    alignItems: 'center',
    height: '32px'
  },

  status: {
    color: ({ status }) => getStatusColor(status, theme)
  },

  date: {
    opacity: '0.35',
    fontStyle: 'italic'
  }
}))

export default useStyles
